import React from "react";
import DashboardRouter from "./DashboardRouter";
import ErrorBoundary from "./Shared/error-boundary/errorBoundary";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./Shared/common.module.scss";

const TOAST_Z_INDEX = 100000;

const App: React.FC = () => {
  return (
    <React.StrictMode>
      <main style={{ background: "#F3F4F6" }}>
        <ErrorBoundary>
          <DashboardRouter />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            newestOnTop
            pauseOnHover
            transition={Zoom}
            style={{ zIndex: TOAST_Z_INDEX }}
          />
        </ErrorBoundary>
      </main>
    </React.StrictMode>
  );
};

export default App;
